import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

export type DealerFormPayload = Pick<Dealer, "name" | "active" | "region" | "city" | "street" | "postal_code" | "phone_nr" | "website_url">;

export const useCreateDealerMutation = () =>
  useTypedMutation<DealerFormPayload, Dealer>({
    mutationFn: async payload => (await ApiInstance.post("/dealers/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: (_, createdDealer) => {
      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      if (!dealers || dealers.some(dealer => dealer.id === createdDealer.id)) return;

      typedQueryClient.setQueryData(DealersDashboardQueryKeys.list, [...dealers, createdDealer]);
    }
  });
